import { useMemo } from "react";
import { useHotkeys } from "react-hotkeys-hook";
import type { Options } from "react-hotkeys-hook";
import { useBuilderStore } from "@circle-react-shared/BuilderUI/Hooks/useBuilderStore";
import { IFRAME_ID } from "../Frames/constants";
import { useIFrameDocument } from "./useIFrameDocument";

const KEYBOARD_SHORTCUTS_MAPPER = {
  deselect_selected_block: "Escape",
} as const;

const defaultOptions: Options = {
  scopes: "builder-ui",
  preventDefault: true,
};

export const useKeyboardShortcuts = (options: Options = defaultOptions) => {
  const selectedBlockPath =
    useBuilderStore(state => state.selectedBlockPath) ?? "";
  const removeBlockSelection = useBuilderStore(
    state => state.removeBlockSelection,
  );

  const iFrameDocument = useIFrameDocument(IFRAME_ID, selectedBlockPath);

  const mainDocumentOptions = useMemo<Options>(
    () => ({
      scopes: options.scopes ?? defaultOptions.scopes,
      preventDefault: options.preventDefault ?? defaultOptions.preventDefault,
      document,
    }),
    [options.scopes, options.preventDefault],
  );

  const iFrameOptions = useMemo<Options>(
    () => ({
      scopes: options.scopes ?? defaultOptions.scopes,
      preventDefault: options.preventDefault ?? defaultOptions.preventDefault,
      enabled: Boolean(iFrameDocument),
      document: iFrameDocument ?? document,
    }),
    [options.scopes, options.preventDefault, iFrameDocument],
  );

  useHotkeys(
    KEYBOARD_SHORTCUTS_MAPPER.deselect_selected_block,
    () => {
      removeBlockSelection();
    },
    mainDocumentOptions,
  );

  useHotkeys(
    KEYBOARD_SHORTCUTS_MAPPER.deselect_selected_block,
    () => {
      removeBlockSelection();
    },
    iFrameOptions,
  );
};
